/**
 * Mapeia currency code (ISO 4217) para country code (ISO 3166-1 alpha-2)
 *
 * Moedas suportadas:
 * - BRL -> BR (Brasil)
 * - USD -> US (Estados Unidos)
 * - COP -> CO (Colômbia)
 * - ARS -> AR (Argentina)
 * - PEN -> PE (Peru)
 * - MXN -> MX (México)
 *
 * @param currencyCode - Código da moeda (ISO 4217)
 * @returns Código do país (ISO 3166-1 alpha-2) ou undefined se não encontrado
 *
 * @example
 * const country = getCountryFromCurrency('BRL') // 'BR'
 * const country = getCountryFromCurrency('USD') // 'US'
 */
export const getCountryFromCurrency = (
  currencyCode?: string
): string | undefined => {
  if (!currencyCode) {
    return undefined
  }

  const normalized = currencyCode.toUpperCase().trim()

  const currencyToCountryMap: Record<string, string> = {
    BRL: 'BR',
    USD: 'US',
    COP: 'CO',
    ARS: 'AR',
    PEN: 'PE',
    MXN: 'MX'
  }

  return currencyToCountryMap[normalized]
}
